<script setup>
import {
    ref,
    getCurrentInstance,
    onMounted,
    watch
} from 'vue'
import { useRoute } from 'vue-router'
import emitter from '../utils/emitter'
import DriverCard from '../components/driverCard.vue'
import KonopabankForm from '../components/konopabankForm.vue'
import PersonaForm from '../components/personaForm.vue'
import RedeemcodeForm from '../components/redeemcodeForm.vue'
import prestigeForm from '../components/prestigeForm.vue'
import {
    DriverStore
} from '../pinia/Driver.js'

const {
    proxy
} = getCurrentInstance()

const Driver = DriverStore()
const route = useRoute()

var dialog = ref(false)
var dialogswitch = ref(false)
var model = ref(1)  // valeur par défaut

// Ouvre le dialogue sur le bon tab quand l'URL est /redeemcode
onMounted(() => {
    if (route.path === '/redeemcode') {
        dialog.value = true
        model.value = '2' // Tab "Redeem code"
        
        // Attendre que le composant soit monté et visible
        setTimeout(() => {
            if (route.query.code) {
                emitter.emit('setRedeemCode', route.query.code)
            }
        }, 100)
        // Émet l'événement avec le code de l'URL
        const code = route.query.code
        if (code) {
            emitter.emit('setRedeemCode', code)
        }
    }
})

watch(() => route.path, (newPath) => {
    if (newPath === '/redeemcode') {
        dialog.value = true
        model.value = '2'
        const code = route.query.code
        if (code) {
            emitter.emit('setRedeemCode', code)
        }
    }
})
const modelswitch = ref()
const error = ref("")

const avatar = ref("")
const name = ref("")

async function save() {

    error.value = false

    if (!!avatar.value && !!name.value) {
        const res = await proxy.$api({
            serviceName: "account",
            methodName: "create_persona",
            parameters: [name.value, avatar.value]
        })

        if (res == "error") {
            error.value = true
        } else {
            Driver.setEasharpptr_p(res)
            GetUserInfo()
            dialogswitch.value = false
            modelswitch.value = 1
            name.value = ""
            avatar.value = ""
        }
    }
}

async function GetUserInfo() {
    const res = await proxy.$api({
        serviceName: "session",
        methodName: "GetUserInfo"
    })

    Driver.setPersona(res.persona)
    Driver.setUser(res.user)
    Driver.setCrew(res.crew)
    Driver.setCurrentCrew(res.crew.current)
    Driver.setOthers(res.others)
    Driver.setLogged(true)
}
</script>

<template>
<v-btn id="menu" icon="mdi">
    <v-avatar @click="dialog = true" :image="'https://cdn.nightriderz.world/images/website/icon-persona/' + Driver.persona.iconIndex + '.jpg'"></v-avatar>
</v-btn>

<v-btn id="menu" @click="dialogswitch = true" icon="mdi-account-switch" title="Switch Driver">
</v-btn>

<v-dialog v-model="dialogswitch" :width="520" scrollable>
    <v-card>
        <v-toolbar dark color="primary">
            <v-icon class="mr-3">mdi-account-switch</v-icon>
            <v-toolbar-title>My Drivers</v-toolbar-title>
            <v-spacer></v-spacer>
            <template v-slot:extension>
                <v-tabs v-model="modelswitch" centered>
                <v-tab value="1">
                    SWITCH DRIVER
                </v-tab>
                <v-tab value="2" v-if="Driver.user.premium == '1'">
                    CREATE DRIVER
                </v-tab>
            </v-tabs>
        </template>
        </v-toolbar>

        <v-card-text>
            <v-window v-model="modelswitch">
                <v-window-item value="1">
                    <div class="driver-cards-list">
                        <DriverCard :data="Driver.persona" :changebis="true" />
                        <DriverCard v-for="driver in Driver.others" :data="driver" :change="true" @closeDialog="dialogswitch = false" />
                    </div>
                </v-window-item>
                <v-window-item value="2">

                            <v-alert 
                                v-if="Driver.others.length + 1 == 6" 
                                color="info" 
                                icon="mdi-information"
                                class="mb-4"
                            >
                                You have reached the maximum number of drivers.
                            </v-alert>

                            <v-alert class="error mb-4" v-if="error" text="This name is unavailable." type="error"></v-alert>

                            <!-- Create Driver Card -->
                            <div class="settings-card">
                                <div class="settings-card-header">
                                    <div class="header-icon">
                                        <v-icon size="28">mdi-account-plus</v-icon>
                                    </div>
                                    <div class="header-content">
                                        <h3 class="settings-title">Create New Driver</h3>
                                        <p class="settings-subtitle">Choose a name and avatar for your new driver</p>
                                    </div>
                                </div>

                                <div class="settings-card-body">
                                    <!-- Driver Name -->
                                    <div class="setting-item">
                                        <div class="setting-info full-width">
                                            <div class="setting-label">
                                                <v-icon size="20" class="mr-2">mdi-account</v-icon>
                                                Driver Name
                                            </div>
                                            <div class="setting-description">
                                                Choose a unique name (3-14 characters, alphanumeric)
                                            </div>
                                            <v-text-field 
                                                v-model="name" 
                                                placeholder="Enter driver name" 
                                                variant="outlined"
                                                density="comfortable"
                                                hide-details
                                                class="setting-input"
                                            ></v-text-field>
                                        </div>
                                    </div>

                                    <v-divider class="my-4"></v-divider>

                                    <!-- Avatar Selection -->
                                    <div class="setting-item">
                                        <div class="setting-info full-width">
                                            <div class="setting-label">
                                                <v-icon size="20" class="mr-2">mdi-face-man</v-icon>
                                                Avatar
                                            </div>
                                            <div class="setting-description">
                                                Select an avatar for your driver
                                            </div>
                                            
                                            <div class="avatar-grid-create">
                                                <span 
                                                    v-for="i in 72" 
                                                    :key="i"
                                                    :class="['avatar-item-create', 'item' + i, {'avatar-selected-create': avatar === i}]"
                                                >
                                                    <label :for="'label' + i">
                                                        <img 
                                                            v-if="i != 26 || i === 0" 
                                                            :src="'https://cdn.nightriderz.world/images/website/icon-persona/' + i + '.jpg'" 
                                                            width="60" 
                                                            height="60"
                                                        >
                                                    </label>
                                                    <input 
                                                        type="radio" 
                                                        :id="'label' + i" 
                                                        name="avatar" 
                                                        @click="avatar = i"
                                                    >
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Create Button -->
                            <v-btn 
                                class="create-btn" 
                                variant="elevated" 
                                color="primary"
                                size="large"
                                @click="save"
                                block
                            >
                                <v-icon class="mr-2">mdi-plus-circle</v-icon>
                                Create Driver
                            </v-btn>

                </v-window-item>
            </v-window>
        </v-card-text>
    </v-card>
</v-dialog>

<v-dialog transition="dialog-bottom-transition" :width="520" v-model="dialog" scrollable>
    <v-card>
        <v-toolbar dark color="primary">
            <v-avatar @click="dialog = true" :image="'https://cdn.nightriderz.world/images/website/icon-persona/' + Driver.persona.iconIndex + '.jpg'"></v-avatar>
            <v-toolbar-title>{{Driver.persona.name}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="dialogswitch = true" icon="mdi-account-switch" title="Switch Driver"></v-btn>
            <template v-slot:extension>
                <v-tabs v-model="model" centered>
                    <v-tab value="1">
                        Driver
                    </v-tab>
                    <v-tab value="4">
                        Prestige
                    </v-tab>
                    <v-tab value="2">
                        Redeem code
                    </v-tab>
                    <v-tab value="3">
                        Konopa Bank
                    </v-tab>
                </v-tabs>
            </template>
        </v-toolbar>

        <v-card-text>
            <v-window v-model="model">
                <v-window-item value="1">
                    <PersonaForm />
                </v-window-item>
                <v-window-item value="2">
                    <RedeemcodeForm :initial-code="route.query.code || ''" />
                </v-window-item>
                <v-window-item value="3">
                    <KonopabankForm />
                </v-window-item>
                <v-window-item value="4">
                    <prestigeForm />
                </v-window-item>
            </v-window>
        </v-card-text>

    </v-card>
</v-dialog>
</template>

<style>
.v-list-item__prepend {
    font-size: 30px !important;
    margin-top: 10px;
}
</style><style scoped>
#menu {
    margin-bottom: 10px !important;
}

.downloadbtn {
    display: flex;
    justify-content: center;
    margin: 10px 0;
}

button {
    margin: initial !important;
}

.grid {
    display: flex;
    flex-wrap: wrap;
    height: 200px;
    overflow-y: scroll;
    overflow-x: hidden;
    width: 100%;
    margin-bottom: 20px;
    margin-top: 5px;
}

.item26 {
    display: none;
}

[type='radio'] {
    position: absolute;
    left: 2px;
    top: 2px;
}

.grid span {
    margin: 5px;
}

/* Modern styles for Create Driver tab */
.settings-card {
    background: rgba(255, 255, 255, 0.03);
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    overflow: hidden;
    margin-bottom: 20px;
}

.settings-card-header {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 20px;
    background: rgba(var(--v-theme-primary), 0.1);
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.header-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    background: rgba(var(--v-theme-primary), 0.2);
    border-radius: 10px;
}

.header-icon .v-icon {
    color: rgb(var(--v-theme-primary));
}

.header-content {
    flex: 1;
}

.settings-title {
    margin: 0;
    font-size: 1.3em;
    font-weight: 600;
    color: rgb(var(--v-theme-primary));
}

.settings-subtitle {
    margin: 4px 0 0 0;
    font-size: 0.85em;
    color: rgba(255, 255, 255, 0.6);
}

.settings-card-body {
    padding: 24px;
}

.setting-item {
    display: flex;
    align-items: flex-start;
    gap: 16px;
}

.setting-info {
    flex: 1;
}

.setting-info.full-width {
    width: 100%;
}

.setting-label {
    display: flex;
    align-items: center;
    font-size: 1em;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.9);
    margin-bottom: 6px;
}

.setting-label .v-icon {
    color: rgba(255, 255, 255, 0.9);
}

.setting-description {
    font-size: 0.85em;
    color: rgba(255, 255, 255, 0.5);
    margin-bottom: 16px;
}

.setting-input {
    margin-top: 0;
}

.avatar-grid-create {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    max-height: 300px;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 8px;
    background: rgba(255, 255, 255, 0.02);
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.05);
}

.avatar-grid-create::-webkit-scrollbar {
    width: 6px;
}

.avatar-grid-create::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.02);
    border-radius: 3px;
}

.avatar-grid-create::-webkit-scrollbar-thumb {
    background: rgba(var(--v-theme-primary), 0.3);
    border-radius: 3px;
}

.avatar-grid-create::-webkit-scrollbar-thumb:hover {
    background: rgba(var(--v-theme-primary), 0.5);
}

.avatar-item-create {
    position: relative;
    cursor: pointer;
}

.avatar-item-create.item26 {
    display: none;
}

.avatar-item-create img {
    border-radius: 8px;
    border: 2px solid rgba(255, 255, 255, 0.1);
    transition: all 0.2s ease;
    cursor: pointer;
}

.avatar-item-create:hover img {
    border-color: rgba(var(--v-theme-primary), 0.5);
    transform: scale(1.05);
}

.avatar-item-create.avatar-selected-create img {
    border-color: rgb(var(--v-theme-primary));
    box-shadow: 0 0 12px rgba(var(--v-theme-primary), 0.5);
}

.avatar-item-create input[type="radio"] {
    position: absolute;
    left: 4px;
    top: 4px;
    accent-color: rgb(var(--v-theme-primary));
    cursor: pointer;
}

.create-btn {
    font-weight: 600;
    letter-spacing: 0.5px;
}

.create-btn .v-icon {
    opacity: 1 !important;
}

.driver-cards-list .driver-card {
    margin-bottom: 20px !important;
}

.driver-cards-list .driver-card:last-child {
    margin-bottom: 0 !important;
}
</style><style>
.v-list-item-title {
    margin: 10px 0 !important;
}
</style>
